// EID-105: serialize the active menu item's id for the `changeMenuItem` event
// payload. The active id is `undefined` whenever the menu has no active child
// — most importantly when a derived menu's children empty out. Passing that
// straight into `JSON.parse(JSON.stringify(...))` throws a SyntaxError
// (`JSON.stringify(undefined)` returns `undefined`, and `JSON.parse('undefined')`
// is invalid JSON), and it fires mid-flush inside a createEffect with no
// ErrorBoundary to catch it — crashing the renderer. Emit `null` in that case
// instead of serializing, so an emptied menu produces a clean no-item event.
export const serializeActiveMenuItem = (
  activeId: string | undefined,
): string | null =>
  activeId === undefined ? null : JSON.parse(JSON.stringify(activeId));
